/* Klantenservice-chat: tekent de state van client.js (support.godu.nl) in het ontwerp "combinatie"/"mobiel".
   Regel: tekst van bezoeker of server gaat alleen via textContent in de pagina, nooit via innerHTML.
   Alleen een e-mailadres, geen naam (minder drempel); dat vragen we pas bij het versturen, in de typbalk. */
(function () {
  'use strict';

  var root = document.querySelector('[data-support-chat]');
  if (!root || !window.SupportChat) return;

  var $ = function (sel) { return root.querySelector(sel); };
  var launcher = $('[data-sc-launcher]');
  var launcherText = $('[data-sc-launcher-text]');
  var badge = $('[data-sc-badge]');
  var panel = $('[data-sc-panel]');
  var body = $('[data-sc-body]');
  var offline = $('[data-sc-offline]');
  var availability = $('[data-sc-availability]');
  var contextBox = $('[data-sc-context]');
  var welcome = $('[data-sc-welcome]');
  var greeting = $('[data-sc-greeting]');
  var welcomeText = $('[data-sc-welcome-text]');
  var expect = $('[data-sc-expect]');
  var expectation = $('[data-sc-expectation]');
  var list = $('[data-sc-messages]');
  var suggestions = $('[data-sc-suggestions]');
  var composer = $('[data-sc-composer]');
  var contactBox = $('[data-sc-contact]');
  var contactLead = $('[data-sc-contact-lead]');
  var textarea = $('[data-sc-text]');
  var attach = $('[data-sc-attach]');
  var fileInput = $('[data-sc-file]');
  var sendBtn = $('[data-sc-send]');
  var sendError = $('[data-sc-send-error]');
  var note = $('[data-sc-note]');

  var identity = window.supportChatIdentity;
  var product = window.supportChatProduct;
  var productImage = window.supportChatProductImage;
  var coarse = window.matchMedia('(pointer: coarse)');

  var chat = window.SupportChat.create({
    widget: 'godu',
    identity: identity && { email: identity.email, timestamp: identity.timestamp, signature: identity.signature },
    // Pagina en product gaan mee, zodat de klantenservice ziet wat de klant bekeek (handleiding §5a).
    // Haalt de klant het product weg (kruisje), dan gaat het niet meer mee.
    context: function () { return { page: location.href, product: product || undefined }; }
  });

  var state = chat.getState();
  var isOpen = false;
  var askContact = false;  // e-mailveld tonen: na de eerste verzendpoging, of meteen als we dicht zijn
  var starting = false;
  var seen = {};           // bericht-id's die al getekend zijn: alleen nieuwe krijgen de animatie
  var firstRender = true;
  var fileUrls = {};       // bijlage-id -> blob-URL, zodat een foto niet bij elke wijziging opnieuw laadt

  /* ---------- hulpjes ---------- */
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function svg(path, size) {
    var ns = 'http://www.w3.org/2000/svg';
    var s = document.createElementNS(ns, 'svg');
    s.setAttribute('width', size || 14); s.setAttribute('height', size || 14);
    s.setAttribute('viewBox', '0 0 24 24'); s.setAttribute('aria-hidden', 'true');
    var p = document.createElementNS(ns, 'path');
    p.setAttribute('d', path); p.setAttribute('fill', 'none'); p.setAttribute('stroke', 'currentColor');
    p.setAttribute('stroke-width', '2.2'); p.setAttribute('stroke-linecap', 'round'); p.setAttribute('stroke-linejoin', 'round');
    s.appendChild(p);
    return s;
  }
  var ICON_CHECK = 'm5 12.5 4.5 4.5L19 7.5';
  var ICON_CLOCK = 'M12 3.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17ZM12 7.5V12l3 2';
  var ICON_ALERT = 'M12 3.5 2.5 20h19ZM12 10v4.5M12 17.2v.1';
  var ICON_FILE = 'M6 3h8l4 4v14H6zM14 3v4h4';
  var ICON_ARROW = 'M7 17 17 7M8 7h9v9';

  function time(iso) {
    var d = new Date(iso);
    return isNaN(d) ? '' : d.toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit' }).replace(':', '.') + ' uur';
  }
  function dayLabel(iso) {
    var d = new Date(iso); if (isNaN(d)) return '';
    var today = new Date(); today.setHours(0, 0, 0, 0);
    var that = new Date(d); that.setHours(0, 0, 0, 0);
    var diff = Math.round((today - that) / 86400000);
    if (diff === 0) return 'Vandaag';
    if (diff === 1) return 'Gisteren';
    return d.toLocaleDateString('nl-NL', { weekday: 'long', day: 'numeric', month: 'long' });
  }
  function showError(node, text) { node.textContent = text; node.hidden = false; }
  function isClosed(s) { return !!(s.config && s.config.open === false); }

  // Tekst met alleen https-links klikbaar; alles gaat als tekstnode of via textContent.
  function fillText(node, text) {
    var re = /https:\/\/[^\s<>"']+/g, last = 0, m;
    text = String(text || '');
    while ((m = re.exec(text))) {
      var url = m[0].replace(/[.,;:!?)]+$/, '');
      if (m.index > last) node.appendChild(document.createTextNode(text.slice(last, m.index)));
      var a = el('a', null, url);
      a.href = url; a.target = '_blank'; a.rel = 'noopener noreferrer';
      node.appendChild(a);
      last = m.index + url.length;
      re.lastIndex = last;
    }
    if (last < text.length) node.appendChild(document.createTextNode(text.slice(last)));
  }

  function attachmentNode(att) {
    var key = att.id != null ? 'id-' + att.id : 'local-' + att.name + '-' + att.size;
    var isImage = /^image\//.test(att.contentType || '');
    var wrap;
    if (isImage) {
      wrap = el('span', 'sc-thumb');
      var img = el('img');
      img.alt = att.name || 'Foto';
      wrap.appendChild(img);
    } else {
      wrap = el('a', 'sc-file');
      wrap.appendChild(svg(ICON_FILE, 18));
      wrap.appendChild(el('span', null, att.name || 'Bestand'));
      wrap.target = '_blank'; wrap.rel = 'noopener';
    }
    function apply(url) { if (isImage) wrap.firstChild.src = url; else wrap.href = url; }
    if (key && fileUrls[key]) apply(fileUrls[key]);
    else chat.fileUrl(att).then(function (url) { if (key) fileUrls[key] = url; apply(url); }).catch(function () {});
    return wrap;
  }

  /* ---------- productcontext en voorbeeldvragen ---------- */
  function renderContext() {
    contextBox.hidden = !product;
    if (!product) return;
    $('[data-sc-product-title]').textContent = product.title;
    var img = $('[data-sc-product-img]');
    if (productImage) { img.src = productImage; img.hidden = false; }
  }
  $('[data-sc-product-remove]').addEventListener('click', function () {
    product = null;
    renderContext();
    renderSuggestions();
    textarea.focus();
  });

  function renderSuggestions() {
    var questions = product
      ? ['Welke maat of uitvoering past bij mij?', 'Wanneer kan dit geleverd worden?']
      : ['Waar is mijn bestelling?', 'Ik wil iets retourneren of melden.'];
    suggestions.querySelectorAll('.sc-prompt').forEach(function (b) { b.remove(); });
    questions.forEach(function (q) {
      var b = el('button', 'sc-prompt'); b.type = 'button';
      b.appendChild(el('span', null, q));
      b.appendChild(svg(ICON_ARROW, 15));
      b.addEventListener('click', function () {
        // Een half getypt bericht nooit overschrijven.
        if (!textarea.value.trim()) textarea.value = q;
        autosize();
        textarea.focus();
        textarea.setSelectionRange(textarea.value.length, textarea.value.length);
      });
      suggestions.appendChild(b);
    });
  }

  /* ---------- gesprek ---------- */
  function renderMessages(s) {
    var nearBottom = body.scrollHeight - body.scrollTop - body.clientHeight < 80;
    var frag = document.createDocumentFragment();
    var lastDay = '';
    var hasTeam = false;
    var lastVisitorIndex = -1;
    s.messages.forEach(function (m, i) {
      if (m.from === 'team') hasTeam = true;
      if (m.from === 'visitor') lastVisitorIndex = i;
    });

    s.messages.forEach(function (m, i) {
      var day = dayLabel(m.at);
      if (day && day !== lastDay) { frag.appendChild(el('li', 'sc-day', day)); lastDay = day; }

      var li = el('li', 'sc-msg sc-msg--' + (m.from === 'team' ? 'team' : 'visitor'));
      if (m.status === 'sending') li.classList.add('sc-msg--sending');
      if (m.status === 'failed') li.classList.add('sc-msg--failed');
      var key = m.clientId || m.id;
      if (!firstRender && !seen[key]) li.classList.add('is-new');
      seen[key] = true;

      if (m.from === 'team') li.appendChild(el('span', 'sc-meta', (m.name || 'Klantenservice') + ' · ' + time(m.at)));

      if (m.text) {
        var bubble = el('div', 'sc-bubble');
        fillText(bubble, m.text);
        li.appendChild(bubble);
      }
      if (m.attachments && m.attachments.length) {
        var files = el('div', 'sc-files');
        m.attachments.forEach(function (a) { files.appendChild(attachmentNode(a)); });
        li.appendChild(files);
      }

      if (m.from === 'visitor') {
        var st;
        if (m.status === 'sending') { st = el('span', 'sc-status'); st.appendChild(svg(ICON_CLOCK)); st.appendChild(document.createTextNode('Wordt verstuurd…')); }
        else if (m.status === 'failed') {
          st = el('span', 'sc-status sc-status--failed'); st.appendChild(svg(ICON_ALERT));
          st.appendChild(document.createTextNode(m.error || 'Niet verstuurd'));
        } else { st = el('span', 'sc-status'); st.appendChild(svg(ICON_CHECK)); st.appendChild(document.createTextNode('Verstuurd · ' + time(m.at))); }
        li.appendChild(st);
        if (m.status === 'failed') {
          var actions = el('div', 'sc-actions');
          var again = el('button', null, 'Opnieuw'); again.type = 'button';
          again.addEventListener('click', function () { chat.retry(m.id).catch(function () {}); });
          var drop = el('button', null, 'Weghalen'); drop.type = 'button';
          drop.addEventListener('click', function () { chat.discard(m.id); });
          actions.appendChild(again); actions.appendChild(drop);
          li.appendChild(actions);
        }
      }
      frag.appendChild(li);

      // Nog geen antwoord: de eerlijke verwachting onder de laatste vraag (handleiding §3).
      if (!hasTeam && i === lastVisitorIndex && m.status !== 'failed' && s.config && s.config.expectation) {
        var wait = el('li', 'sc-waiting');
        wait.appendChild(svg(ICON_CLOCK, 16));
        wait.appendChild(el('span', null, s.config.expectation));
        frag.appendChild(wait);
      }
    });
    list.replaceChildren(frag);
    if (nearBottom || firstRender) body.scrollTop = body.scrollHeight;
    firstRender = false;
  }

  function render(s) {
    state = s;
    var cfg = s.config || {};
    var closed = isClosed(s);
    var hasMessages = !!(s.contact && s.messages.length);

    availability.textContent = closed ? 'Nu afwezig · antwoord per e-mail' : 'Persoonlijk advies & klantenservice';
    greeting.textContent = closed ? 'Laat gerust je vraag achter.' : 'Waarmee kunnen we je helpen?';
    welcomeText.textContent = closed ? 'We beantwoorden je vraag per e-mail.' : 'Stel je vraag. We denken graag met je mee.';
    expectation.textContent = cfg.expectation || '';
    expect.hidden = !cfg.expectation;
    if (cfg.maxMessageChars) textarea.maxLength = cfg.maxMessageChars;

    offline.hidden = s.connection !== 'offline';
    welcome.hidden = hasMessages;
    list.hidden = !hasMessages;
    suggestions.hidden = hasMessages || closed;

    // E-mail: alleen zolang er geen gesprek is, en niet voor een ingelogde klant (die sturen we mee).
    var needContact = !s.contact && !identity;
    contactBox.hidden = !(needContact && (askContact || closed));
    contactLead.textContent = closed ? 'Je antwoord ontvangen per e-mail' : 'Waar mogen we je antwoorden?';
    attach.hidden = !s.contact;

    note.textContent = closed ? 'Je kunt je vraag alvast achterlaten.'
      : hasMessages ? 'Je gesprek blijft bewaard, ook als je de chat sluit.'
      : 'Stel gerust je vraag.';
    textarea.placeholder = hasMessages ? 'Typ je bericht…' : 'Typ je vraag…';

    var unread = s.unread || 0;
    badge.hidden = isOpen || unread < 1;
    badge.textContent = unread > 9 ? '9+' : String(unread);
    launcherText.textContent = unread > 0 ? 'Nieuw antwoord' : 'Chat met ons';

    if (hasMessages) renderMessages(s); else firstRender = true;
    autosize();
  }

  /* ---------- openen en sluiten ---------- */
  var mobile = window.matchMedia('(max-width: 767px)');
  function open() {
    if (isOpen) return;
    isOpen = true;
    panel.hidden = false;
    root.classList.add('is-open');
    launcher.setAttribute('aria-expanded', 'true');
    if (mobile.matches) document.documentElement.classList.add('sc-lock');
    chat.setOpen(true);
    render(chat.getState());
    if (state.contact && state.messages.length) body.scrollTop = body.scrollHeight;
    // Op een telefoon niet meteen het toetsenbord openen: dan valt het welkom weg.
    setTimeout(function () { (mobile.matches ? $('[data-sc-close]') : textarea).focus({ preventScroll: true }); }, 50);
  }
  function close() {
    if (!isOpen) return;
    isOpen = false;
    panel.hidden = true;
    root.classList.remove('is-open');
    launcher.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('sc-lock');
    chat.setOpen(false);
    render(chat.getState());
    launcher.focus({ preventScroll: true });
  }
  // Op desktop blijft de knop onder het venster staan en werkt hij als aan/uit.
  launcher.addEventListener('click', function () { if (isOpen) close(); else open(); });
  $('[data-sc-close]').addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen) close(); });
  // Andere knoppen op de site (bijv. het headset-icoon) kunnen de chat openen met data-support-chat-open.
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-support-chat-open]');
    if (t && !root.hidden) { e.preventDefault(); open(); }
  });

  /* ---------- typbalk ---------- */
  var emailInput = composer.elements.email;

  function autosize() {
    textarea.style.height = 'auto';
    textarea.style.height = Math.min(Math.max(textarea.scrollHeight, 44), 110) + 'px';
    sendBtn.disabled = starting || !textarea.value.trim();
  }
  textarea.addEventListener('input', function () { autosize(); sendError.hidden = true; });
  // Desktop: Enter verstuurt, Shift+Enter is een nieuwe regel. Telefoon: Enter is een nieuwe regel (ontwerp "mobiel").
  textarea.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || e.isComposing) return;
    if (coarse.matches ? (e.ctrlKey || e.metaKey) : !e.shiftKey) { e.preventDefault(); send(); }
  });
  composer.addEventListener('submit', function (e) { e.preventDefault(); send(); });

  // Eerste bericht zonder gesprek: eerst e-mail, dan starten, dan pas versturen.
  // Een naam sturen we alleen mee als we die kennen (ingelogde klant).
  function startThenSend(text) {
    var email;
    if (identity) {
      email = identity.email;
    } else {
      if (contactBox.hidden) {
        askContact = true;
        render(state);
        emailInput.focus();
        return;
      }
      email = emailInput.value.trim();
      var valid = !!email && emailInput.validity.valid;
      emailInput.setAttribute('aria-invalid', valid ? 'false' : 'true');
      if (!valid) { showError(sendError, 'Vul een geldig e-mailadres in.'); emailInput.focus(); return; }
    }
    starting = true;
    autosize();
    chat.start({ name: (identity && identity.name) || '', email: email, website: composer.elements.website.value })
      .then(function () {
        textarea.value = '';
        return chat.send(text).catch(sendFailed);
      })
      .catch(function (err) { showError(sendError, err && err.message ? err.message : 'Dat lukte niet. Probeer het nog eens.'); })
      .then(function () { starting = false; autosize(); textarea.focus(); });
  }

  function sendFailed(err) {
    // Een mislukt bericht blijft zichtbaar met "Opnieuw"; andere fouten (te lang, te vaak) tonen we hier.
    if (err && err.code !== 'network') showError(sendError, err.message || 'Versturen lukte niet.');
  }

  function send() {
    var text = textarea.value.trim();
    if (!text || starting) return;
    sendError.hidden = true;
    if (!state.contact) { startThenSend(text); return; }
    textarea.value = '';
    autosize();
    body.scrollTop = body.scrollHeight;
    chat.send(text).catch(sendFailed);
    textarea.focus();
  }

  fileInput.addEventListener('change', function () {
    var file = fileInput.files && fileInput.files[0];
    fileInput.value = '';
    if (!file) return;
    sendError.hidden = true;
    chat.sendFile(file).catch(function (err) {
      if (err && err.code !== 'network') showError(sendError, err.message || 'Dit bestand kon niet mee.');
    });
  });

  /* ---------- knop boven een vaste balk onderin houden ---------- */
  var bars = document.querySelectorAll('.mobile-sticky-atc, [data-sticky-cta]');
  var raf = 0;
  function measure() {
    raf = 0;
    var vh = window.innerHeight, offset = 0;
    bars.forEach(function (b) {
      var r = b.getBoundingClientRect();
      if (r.height > 0 && r.bottom >= vh - 2 && r.top < vh && getComputedStyle(b).visibility !== 'hidden') {
        offset = Math.max(offset, vh - r.top);
      }
    });
    root.style.setProperty('--sc-offset', offset + 'px');
  }
  function schedule() { if (!raf) raf = requestAnimationFrame(measure); }
  if (bars.length) {
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    if (window.ResizeObserver) { var ro = new ResizeObserver(schedule); bars.forEach(function (b) { ro.observe(b); }); }
  }

  /* ---------- starten ---------- */
  renderContext();
  renderSuggestions();
  chat.on('change', render);
  chat.init().then(function (s) {
    render(s || chat.getState());
    root.hidden = false;   // pas tonen als de server de chat kent
    measure();
  }).catch(function (err) {
    // Server heeft de chat (nog) niet aan: geen knop tonen. Zie de handleiding, §6.
    if (window.console) console.warn('[support-chat] niet gestart:', err && (err.code || err.message));
  });
})();
